{ TrelloStorage } = require '@trello/storage'
log = require 'app/scripts/debug/log'

module.exports = new class
  delta: TrelloStorage.get('serverTimeDelta')
  updateServerTime: (time) ->
    @delta = (new Date(time) - new Date())
    TrelloStorage.set('serverTimeDelta', @delta)
    log('time', 'delta', @delta)

  serverToClient: (time) ->
    new Date((new Date(time)) - @delta)
